import Icon from '../icon/Icon';
import PasswordIconButton from '../password/PasswordIconButton';
import PaymentIcon from '../paymentIcon/PaymentIcon';
export var TYPE_TEXT = 'text';
export var TYPE_PASSWORD = 'password';
export var TYPE_EMAIL = 'email';
export var TYPE_URL = 'url';
export var TYPE_TEL = 'tel';
export var TYPE_SEARCH = 'search';
export var TYPE_DATE = 'date';
export var TYPE_NUMBER = 'number';
export var TYPES = [TYPE_TEXT, TYPE_PASSWORD, TYPE_EMAIL, TYPE_URL, TYPE_TEL, TYPE_SEARCH, TYPE_DATE, TYPE_NUMBER];
export var CHILD_COMPONENT_WHITELIST = [Icon, PaymentIcon, PasswordIconButton];